<main class="venue-list">
	<ui-porto-bank-swiper-container
		class="swiper-container"
		style="
			width: 100%;
			max-width: 100%;
			padding: 32px 16px;
			background-color: var(--content-primary-darkest);
			box-sizing: border-box;
		"
	>
		<ng-container *ngFor="let banner of banners">
			<swiper-slide *ngIf="!banner.removeWhenLoggedIn">
				<div class="container-large">
					<figure class="image-container" (click)="banner.click()">
						<img
							*ngIf="!isMobile"
							[src]="banner.imageDesktop"
							[alt]="banner.alt"
							style="cursor: pointer"
						/>
						<img
							*ngIf="isMobile"
							[src]="banner.imageMobile"
							[alt]="banner.alt"
							style="cursor: pointer"
						/>
						<div class="image-text">
							<h2 class="image-title">{{ banner.title }}</h2>
						</div>
					</figure>
					<p class="image-description" [innerHTML]="banner.text"></p>
					<button mat-button color="primary" class="image-btn" *ngIf="banner.buttonText">
						{{ banner.buttonText }}
						<mat-icon
							iconPositionEnd
							svgIcon="porto-bank-icons:right_arrow"
							style="--icon-color: var(--content-on-color)"
						></mat-icon>
					</button>
				</div>
			</swiper-slide>
		</ng-container>
	</ui-porto-bank-swiper-container>

	<section class="venue-list__container">
		<article style="margin-top: 20px">
			<feature-porto-bank-filter></feature-porto-bank-filter>
		</article>

		@if (isLoading$ | async) {
			<ui-porto-bank-loading-page />
		} @else {
			<!-- Card list -->
			<h2 class="title">Restaurantes em destaque</h2>
			<feature-porto-bank-venue-card-list />
		}
	</section>
</main>
